// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
import AccordionBlock from '~/components/sitecore/accordion-block'
import Address from '~/components/sitecore/address'
import AutomatedContentList from '~/components/sitecore/automated-content-list'
import AutomatedContentListTile from '~/components/sitecore/automated-content-list-tile'
import BedroomSearchForm from '~/components/sitecore/bedroom-search-form'
import Bookingfor from '~/components/sitecore/bedroom-search-form/menus/bookingFor'
import Dates from '~/components/sitecore/bedroom-search-form/menus/dates'
import Guests from '~/components/sitecore/bedroom-search-form/menus/guests'
import Locations from '~/components/sitecore/bedroom-search-form/menus/locations'
import BodyEditorialBlock from '~/components/sitecore/body-editorial-block'
import BodyEditorialVideo from '~/components/sitecore/body-editorial-video'
import Card from '~/components/sitecore/card'
import CardGroup from '~/components/sitecore/card-group'
import Carousel from '~/components/sitecore/carousel'
import CarouselCard from '~/components/sitecore/carousel-card'
import CarouselGallery from '~/components/sitecore/carousel-gallery'
import CarouselTile from '~/components/sitecore/carousel-tile'
import ContentList from '~/components/sitecore/content-list'
import ContentListTile from '~/components/sitecore/content-list-tile'
import Cta from '~/components/sitecore/cta'
import CustomImage from '~/components/sitecore/custom-image'
import CustomPicture from '~/components/sitecore/custom-picture'
import DoubleText from '~/components/sitecore/double-text'
import EditorialBodyThree from '~/components/sitecore/editorial-body-three'
import EditorialComponent from '~/components/sitecore/editorial-component'
import EditorialCta from '~/components/sitecore/editorial-cta'
import EditorialFullImage from '~/components/sitecore/editorial-full-image'
import EditorialHeader from '~/components/sitecore/editorial-header'
import EditorialLandscapeImage from '~/components/sitecore/editorial-landscape-image'
import EditorialPortraitImage from '~/components/sitecore/editorial-portrait-image'
import EditorialQuote from '~/components/sitecore/editorial-quote'
import EditorialRichText from '~/components/sitecore/editorial-rich-text'
import FeaturedNote from '~/components/sitecore/featured-note'
import FilterComponent from '~/components/sitecore/filter-component'
import FilteredNotes from '~/components/sitecore/filtered-notes'
import GalleryStack from '~/components/sitecore/gallery-stack'
import GridGallery from '~/components/sitecore/grid-gallery'
import GridGalleryImage from '~/components/sitecore/grid-gallery-image'
import Header from '~/components/sitecore/header'
import MenuItem from '~/components/sitecore/header/menu-item'
import MenuItemMobile from '~/components/sitecore/header/menu-item-mobile'
import HeaderImageEditorial from '~/components/sitecore/header-image-editorial'
import HeaderVideoEditorial from '~/components/sitecore/header-video-editorial'
import Heading from '~/components/sitecore/heading'
import Hero from '~/components/sitecore/hero'
import ImageBlock from '~/components/sitecore/image-block'
import LandscapeImage from '~/components/sitecore/landscape-image'
import LocationsList from '~/components/sitecore/locations-list'
import locationimage from '~/components/sitecore/locations-list/location-image'
import NoteFooter from '~/components/sitecore/note-footer'
import NullStateImage from '~/components/sitecore/null-state-image'
import NullStateSection from '~/components/sitecore/null-state-section'
import DotcomHomePage from '~/components/sitecore/pages/dotcom-home-page'
import HouseNotesLandingPage from '~/components/sitecore/pages/house-notes-landing-page'
import LocationsPage from '~/components/sitecore/pages/locations-page'
import NoteDetails from '~/components/sitecore/pages/note-details'
import PerkDetails from '~/components/sitecore/pages/perk-details'
import PreferencedNotes from '~/components/sitecore/preferenced-notes'
import ScNavigationItem from '~/components/sitecore/sc-navigation-item'
import ScRender from '~/components/sitecore/sc-render'
import SecondaryNavigation from '~/components/sitecore/secondary-navigation'
import Section from '~/components/sitecore/section'
import SubscriptionBlock from '~/components/sitecore/subscription-block'
import TermsAndConditions from '~/components/sitecore/terms-and-conditions'
import ThreeImageGallery from '~/components/sitecore/three-image-gallery'
import TileImage from '~/components/sitecore/tile-image'
import TileImageContainer from '~/components/sitecore/tile-image-container'
import TwoImageGallery from '~/components/sitecore/two-image-gallery'
import VimeoVideo from '~/components/sitecore/vimeo-video'
import WhiteBoard from '~/components/sitecore/white-board'
import WhiteBoardWithButton from '~/components/sitecore/white-board-with-button'

const components = new Map()
components.set('AccordionBlock', AccordionBlock)
components.set('Address', Address)
components.set('AutomatedContentList', AutomatedContentList)
components.set('AutomatedContentListTile', AutomatedContentListTile)
components.set('BedroomSearchForm', BedroomSearchForm)
components.set('Bookingfor', Bookingfor)
components.set('Dates', Dates)
components.set('Guests', Guests)
components.set('Locations', Locations)
components.set('BodyEditorialBlock', BodyEditorialBlock)
components.set('BodyEditorialVideo', BodyEditorialVideo)
components.set('Card', Card)
components.set('CardGroup', CardGroup)
components.set('Carousel', Carousel)
components.set('CarouselCard', CarouselCard)
components.set('CarouselGallery', CarouselGallery)
components.set('CarouselTile', CarouselTile)
components.set('ContentList', ContentList)
components.set('ContentListTile', ContentListTile)
components.set('Cta', Cta)
components.set('CustomImage', CustomImage)
components.set('CustomPicture', CustomPicture)
components.set('DoubleText', DoubleText)
components.set('EditorialBodyThree', EditorialBodyThree)
components.set('EditorialComponent', EditorialComponent)
components.set('EditorialCta', EditorialCta)
components.set('EditorialFullImage', EditorialFullImage)
components.set('EditorialHeader', EditorialHeader)
components.set('EditorialLandscapeImage', EditorialLandscapeImage)
components.set('EditorialPortraitImage', EditorialPortraitImage)
components.set('EditorialQuote', EditorialQuote)
components.set('EditorialRichText', EditorialRichText)
components.set('FeaturedNote', FeaturedNote)
components.set('FilterComponent', FilterComponent)
components.set('FilteredNotes', FilteredNotes)
components.set('GalleryStack', GalleryStack)
components.set('GridGallery', GridGallery)
components.set('GridGalleryImage', GridGalleryImage)
components.set('Header', Header)
components.set('MenuItem', MenuItem)
components.set('MenuItemMobile', MenuItemMobile)
components.set('HeaderImageEditorial', HeaderImageEditorial)
components.set('HeaderVideoEditorial', HeaderVideoEditorial)
components.set('Heading', Heading)
components.set('Hero', Hero)
components.set('ImageBlock', ImageBlock)
components.set('LandscapeImage', LandscapeImage)
components.set('LocationsList', LocationsList)
components.set('location-image', locationimage)
components.set('NoteFooter', NoteFooter)
components.set('NullStateImage', NullStateImage)
components.set('NullStateSection', NullStateSection)
components.set('DotcomHomePage', DotcomHomePage)
components.set('HouseNotesLandingPage', HouseNotesLandingPage)
components.set('LocationsPage', LocationsPage)
components.set('NoteDetails', NoteDetails)
components.set('PerkDetails', PerkDetails)
components.set('PreferencedNotes', PreferencedNotes)
components.set('ScNavigationItem', ScNavigationItem)
components.set('ScRender', ScRender)
components.set('SecondaryNavigation', SecondaryNavigation)
components.set('Section', Section)
components.set('SubscriptionBlock', SubscriptionBlock)
components.set('TermsAndConditions', TermsAndConditions)
components.set('ThreeImageGallery', ThreeImageGallery)
components.set('TileImage', TileImage)
components.set('TileImageContainer', TileImageContainer)
components.set('TwoImageGallery', TwoImageGallery)
components.set('VimeoVideo', VimeoVideo)
components.set('WhiteBoard', WhiteBoard)
components.set('WhiteBoardWithButton', WhiteBoardWithButton)

export default function componentFactory (componentName) {
  return components.get(componentName)
}
